import * as aor from "react-admin";
import React from "react";
import CardActions from "@material-ui/core/CardActions";
import FilteredRoleSelect from "../../components/FilteredRoleSelect";
import { Field } from "redux-form";
import UserSession from "../../common/userSession";

const checkSaveDisabled = props => {
    if (props.record) {
        switch (UserSession.get("USER_COMPANY_ROLE")) {
            case "company_trigger":
                return props.record.role_id === 3 ? true : false;
            case "admin_ts_var":
                return props.record.role_id === 5 ||
                    props.record.role_id === 3 ||
                    props.record.role_id === 4
                    ? true
                    : false;
            default:
                return false;
        }
    }
};

const MyToolbar = props => (
    <aor.Toolbar {...props}>
        <aor.SaveButton
            redirect="list"
            submitOnEnter={true}
            disabled={checkSaveDisabled(props)}
        />
    </aor.Toolbar>
);

const renderFilteredRoleSelect = props => {
    return <Field {...props} name="role_id" component={FilteredRoleSelect} />;
};

const Actions = ({ basePath, data }) => {
    return (
        <CardActions
            style={{ zIndex: 2, display: "inline-block", float: "right" }}
        >
            <aor.ListButton basePath={basePath} />
        </CardActions>
    );
};

export default props => (
    <aor.Edit
        {...props}
        undoable={true}
        actions={<Actions />}
        title={"resources.roles.nameSingular"}
    >
        <aor.SimpleForm toolbar={<MyToolbar />}>
            <aor.ReferenceField
                source="user_id"
                reference="users"
                linkType={false}
            >
                <aor.TextField source="username" />
            </aor.ReferenceField>
            <aor.ReferenceField
                source="company_id"
                reference="companies"
                linkType={false}
                allowEmpty
            >
                <aor.TextField source="name" />
            </aor.ReferenceField>
            {renderFilteredRoleSelect(props)}
        </aor.SimpleForm>
    </aor.Edit>
);



// WEBPACK FOOTER //
// ./src/resources/RoleMappings/Edit.js